export default __webpack_public_path__ + "static/media/icon-back-header.d46cd19c.svg";